import { useState, useEffect } from 'react'
import { Helmet } from 'react-helmet-async'
import { useProject } from '../context/ProjectContext'
import { socketEventEmitter } from '../socket'
import { Box } from '@mui/material'
import ProjectService from '../services/ProjectService'
import PageService from '../services/PageService'
import Header from '../components/Header'
import Sidebar from '../components/Sidebar'
import BreadcrumbsNav from '../components/BreadcrumbsNav'
import AddPageModal from '../components/modals/AddPageModal'
import PagesContent from '../components/pages/PagesContent'

const Pages = () => {
  const { selectedProject } = useProject()

  const [prevSitemap, setPrevSitemap] = useState([])
  const [sitemap, setSitemap] = useState([])
  const [addPageModalOpen, setAddPageModalOpen] = useState(false)
  const [pageURL, setPageURL] = useState('')
  const [pagesToggler, setPagesToggler] = useState(false)
  const [prevPages, setPrevPages] = useState([])
  const [pages, setPages] = useState([])

  useEffect(() => {
    const fetchSitemap = async () => {
      try {
        const oldSiteMap = [...sitemap]
        const res = await ProjectService.getProjectSitemapByProjectId(selectedProject.id)
        setPrevSitemap(oldSiteMap)
        setSitemap([res])
      } catch (error) {
        console.log(error?.response?.data?.error || error.message)
      }
    }

    const fetchPages = async () => {
      try {
        const oldPages = [...pages]
        const pagesData = await PageService.getPagesByProjectId(selectedProject.id)
        setPrevPages(oldPages)
        setPages(pagesData)
      } catch (error) {
        console.log(error?.response?.data?.error || error.message)
      }
    }

    const fetchData = async () => {
      await fetchSitemap()
      await fetchPages()
    }

    if (selectedProject?.id) {
      fetchData()
    }

    const refreshPages = async () => {
      try {
        if (!selectedProject?.id) return
        const pagesRes = await PageService.getPages(selectedProject.id)
        setPrevPages(pages)
        setPages(pagesRes.pages || [])
      } catch (e) {
        console.error('Failed to refresh pages after socket event', e)
      }
    }

    const handleTaskCompleted = () => {
      refreshPages()
    }

    const handleTaskFailed = () => {
      refreshPages()
    }

    const handleNewTaskAdded = () => {
      refreshPages()
    }

    socketEventEmitter.on('taskCompleted', handleTaskCompleted)
    socketEventEmitter.on('taskFailed', handleTaskFailed)
    socketEventEmitter.on('newTaskAdded', handleNewTaskAdded)

    return () => {
      socketEventEmitter.off('taskCompleted', handleTaskCompleted)
      socketEventEmitter.off('taskFailed', handleTaskFailed)
      socketEventEmitter.off('newTaskAdded', handleNewTaskAdded)
    }
  // eslint-disable-next-line
  }, [selectedProject?.id, pagesToggler])

  const handleAddPageOpen = () => {
    setAddPageModalOpen(true)
  }

  return (
    <Box className="pages rootWrapper">
      <Helmet>
        <title>{`Treegress - ${selectedProject?.name} Pages`}</title>
      </Helmet>
      <Header/>
      <Box className="srollContent">
        <Sidebar />
        <Box className="pagesMainContainer">
          <BreadcrumbsNav pageLabel="pages"/>
          <PagesContent
            projectID={selectedProject?.id}
            pagesList={pages}
            prevPagesList={prevPages}
            sitemap={sitemap}
            prevSitemap={prevSitemap}
            handleAddPageOpen={handleAddPageOpen}
            pagesToggler={pagesToggler}
            setPagesToggler={setPagesToggler}
          />
        </Box>
      </Box>
      <AddPageModal
        projectID={selectedProject ? selectedProject.id : null}
        pages={pages}
        sitemap={sitemap}
        addPageModalOpen={addPageModalOpen}
        setAddPageModalOpen={setAddPageModalOpen}
        pageURL={pageURL}
        setPageURL={setPageURL}
        pagesToggler={pagesToggler}
        setPagesToggler={setPagesToggler}
      />
    </Box>
  )
}

export default Pages
